<template>
    <div class="row mb-2">
        <div class="col">
            <select v-if="clients" class="form-control" v-model="client_id">
                <option :value="0" selected>{{ $trans.get("__JSON__.Choose client") }}</option>
                <option v-for="item in clients" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>
    </div>

    <input type="hidden" name="client_id" v-model="client_id">

    <div v-if="relateprojects && projects" class="row mb-1" v-for="project_id in relateprojects" :key="project_id">
        <input type="hidden" name="projects[]" :value="project_id">
        <div class="col-10">
            <input class="form-control" type="text" :value="getProject(project_id)?.name" readonly>
        </div>
        <div class="col-2 p-2 text-center">
            <i class="fa fa-trash text-danger" @click="removeProject(project_id)"></i>
        </div>
    </div>

    <div class="row" v-if="client_id > 0 && projects">
        <div class="col-10">
            <select v-if="clientProjects" class="form-control" v-model="project_id" id="project_id">
                <option :value="0" selected>{{ $trans.get("__JSON__.Choose project") }}</option>
                <option v-for="item in clientProjects" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>
        <div class="col-2 text-center">
            <a href="#" class="btn btn-primary" @click.prevent="addProject">{{ $trans.get('__JSON__.Add project') }}</a>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import getClients from "../composables/getClients";
import getProjects from "../composables/getProjects";

export default {
    setup() {
        const { clients, clients_error, loadClients } = getClients();
        loadClients();

        const { projects, projects_error, loadProjects } = getProjects();
        loadProjects();

        return { clients, projects };
    },
    name: "SubprojectProjects",
    created() {
        this.relateprojects = this.relatedprojects ?? [];
        this.client_id = this.related_client_id ?? 0;
    },
    props: {
        relatedprojects: Array,
        related_client_id: Number
    },
    data() {
        return {
            client_id: 0,
            project_id: 0,
            relateprojects: []
        };
    },
    watch: {
        client_id: {
            handler(newValue, oldValue) {
                console.log("Client id", newValue);
            }
        }
    },
    computed: {
        clientProjects() {
            if (this.client_id == 0) {
                return [];
            }

            const projects = this.projects.filter((item) => item.client_id == this.client_id);
            return projects;

        }
    },
    mounted() {
    },
    methods: {
        getProject(project_id) {
            return this.projects.find((item) => item.id == project_id);
        },
        addProject() {
            this.relateprojects.push(this.project_id);
            this.project_id = 0;
        },
        removeProject(project_id) {
            const index = this.relateprojects.indexOf(project_id);
            if (index > -1) {
                this.relateprojects.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
    }
};
</script>

<style scoped></style>
